import { createStyles, makeStyles } from '@hawkins/styles';
var generateThemeVariables = function (theme) {
    var hawkins = theme.hawkins;
    if (hawkins.theme === 'light') {
        return {
            backgroundColor: hawkins.ui.backgroundColor1,
            borderWidth: hawkins.ui.borderWidthRegular,
            borderColor: hawkins.ui.borderColorXlight,
        };
    }
    return {
        backgroundColor: hawkins.ui.backgroundColor2,
        borderWidth: hawkins.ui.borderWidthRegular,
        borderColor: hawkins.ui.borderColorXlight,
    };
};
export var cardHeaderStyles = function (theme) {
    var hawkins = theme.hawkins, hawkinsVariables = theme.hawkinsVariables;
    var themeVariables = generateThemeVariables(theme);
    return createStyles({
        /** Class name to apply to the root of the component */
        root: {
            color: hawkins.textColor.textColorRegular,
            padding: "".concat(hawkinsVariables.spacings.space4, " ").concat(hawkinsVariables.spacings.space4, " 0 ").concat(hawkinsVariables.spacings.space4),
            fontFamily: hawkinsVariables.fontFamily.fontFamilySans,
            borderTopLeftRadius: hawkinsVariables.borderRadius.borderRadius0,
            borderTopRightRadius: hawkinsVariables.borderRadius.borderRadius0,
        },
        /** Class name to apply when `dividerTop` is true */
        rootDividerBottom: {
            borderBottom: "".concat(themeVariables.borderWidth, " solid ").concat(themeVariables.borderColor),
            paddingBottom: hawkinsVariables.spacings.space4,
        },
        /** Class name to apply when 'fullScreen' is true */
        rootFullScreen: {
            display: 'flex',
            alignItems: 'center',
            height: hawkinsVariables.sizings.size6,
            padding: hawkinsVariables.spacings.space2,
            borderRadius: hawkinsVariables.borderRadius.borderRadius1,
            boxShadow: hawkins.elevation.boxShadow2,
            backgroundColor: themeVariables.backgroundColor,
        },
        /** Class name to apply when `square` is true */
        rootSquare: {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
        },
    });
};
export var useCardHeaderStyles = makeStyles(cardHeaderStyles, { name: 'Hawkins-CardHeader' });
